import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

/**
 * 注文コード割当コード一覧取得サービス
 *
 * @export GetOrderNumQuotaCodeListService
 * @class GetOrderNumQuotaCodeListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetOrderNumQuotaCodeListService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetOrderNumQuotaCodeListService
   */
  private successFunc: Function;

  vo = {
    orderCode: '',
    pCode: '',
    getType: '',
    mediumType: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetOrderNumQuotaCodeListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        PlanGoodsMedium: {
          condition: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode,
            GetType: this.vo.getType,
            MediumType: this.vo.mediumType
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetOrderNumQuotaCodeListService
   */
  execute(vo: any, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getOrderNumQuotaCodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetOrderNumQuotaCodeListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
